import type { FlagIcon } from '@constants/countryDetails'

export const Be: FlagIcon = ({ testId, ...rest }) => (
  <svg viewBox='0 0 512 512' data-testid={testId} {...rest}>
    <path
      fill='#000'
      d='M256 0c141.4 0 256 114.6 256 256s-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0z'
    />
    <path
      fill='#fdd216'
      d='M256 0c141.4 0 256 114.6 256 256s-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0z'
      clipPath='polygon(33% 0%, 33% 100%, 66% 100%, 66% 0%)'
    />
    <path
      fill='#d80027'
      d='M256 0c141.4 0 256 114.6 256 256s-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0z'
      clipPath='polygon(66% 0%, 66% 100%, 100% 100%, 100% 0%)'
    />
  </svg>
)
